import React from 'react';

function CutleryIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
            <path d="M9243.294,22653.5a1,1,0,0,1-1-1v-9.25c0-.021,0-.043,0-.062h-2.151v-4.691c0-5.645,2.434-7.5,5.93-7.5v12.189h0c0,.02,0,.041,0,.063v9.25a1,1,0,0,1-1,1Zm-10.4,0a1,1,0,0,1-1-1v-11.189a1.884,1.884,0,0,1-1.888-1.871v-7.5a.944.944,0,0,1,1.888,0v3.746h.012a.436.436,0,0,0-.012.092.472.472,0,0,0,.943,0,.616.616,0,0,0,0-.092h.011v-3.746a.944.944,0,0,1,1.888,0v3.746h.012a.248.248,0,0,0-.012.092.472.472,0,0,0,.944,0,.483.483,0,0,0-.006-.092h.011v-3.746a.944.944,0,0,1,1.888,0v7.5a1.885,1.885,0,0,1-1.888,1.871v11.189a1,1,0,0,1-1,1Z"
                  transform="translate(-9226.039 -22630.25)"/>
        </svg>
    );
}

export default CutleryIcon;